import { useAppSelector } from '../../../../../hooks/reduxHooks';
import {
    useAddCarcinogenicReportResponsibleMutation,
    useDeleteCarcinogenicReportResponsibleMutation,
    useEditCarcinogenicReportResponsibleMutation
} from '../../../../../services/carcinogenicApi';

const useResponsibles = () => {
    const responsibles = useAppSelector(
        (state) => state?.carcinogenicReport?.carcinogenicReport?.responsables || []
    );

    const [addResponsible, { isLoading: isAddingResponsible }] =
        useAddCarcinogenicReportResponsibleMutation();
    const [editResponsible, { isLoading: isEditingResponsible }] =
        useEditCarcinogenicReportResponsibleMutation();
    const [deleteResponsible, { isLoading: isDeletingResponsible }] =
        useDeleteCarcinogenicReportResponsibleMutation();

    return {
        responsibles,
        isAddingResponsible,
        isEditingResponsible,
        isDeletingResponsible,
        addResponsible,
        editResponsible,
        deleteResponsible
    };
};

export default useResponsibles;
